/* AeroSims, eSIM-Geraeteliste fuer /pages/compatible-devices (Section compatible-devices-premium).
   GENERIERT von crawler-sicht-2026-10-09/werkzeug/geraete/build_devices_asset.js aus vorlage/as-devices.js. Nicht von Hand aendern.
   Die Liste steht fertig im HTML (Snippets as-devices-*, 393 Geraete, 18 Marken, Stand 2026-09-03).
   Dieses Skript bedient sie nur: Suche, Hinweis auf- und zuklappen, Marke ganz zeigen. Es enthaelt keine Geraetedaten,
   kein Tracking, keinen Netzaufruf. Ohne dieses Skript ist die ganze Liste offen sichtbar.
   Init idempotent (dataset.asBereit), haengt an DOMContentLoaded + shopify:section:load + pageshow. */
(function () {
  function norm(s) {
    s = String(s || '').toLowerCase();
    try { s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); } catch (e) {}
    s = s.replace(/\+/g, ' plus ')
         .replace(/[^a-z0-9]+/g, ' ')
         .replace(/([a-z])([0-9])/g, '$1 $2')
         .replace(/([0-9])([a-z])/g, '$1 $2')
         .replace(/\s+/g, ' ').trim();
    return s;
  }
  function tokens(s) { var n = norm(s); return n ? n.split(' ') : []; }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function starten(root, grid, tEl) {
    var T = {};
    try { T = JSON.parse(tEl.textContent); } catch (e) { T = {}; }

    /* ---- Zeilen aus dem vorhandenen HTML lesen (Reihenfolge der Datenquelle steht in data-i) ---- */
    var devs = [];
    var cards = grid.querySelectorAll('.cd__card');
    for (var c = 0; c < cards.length; c++) {
      var nameEl = cards[c].querySelector('.cd__cardname');
      var brand = nameEl ? nameEl.textContent : '';
      var rows = cards[c].querySelectorAll('.cd__row');
      for (var r = 0; r < rows.length; r++) {
        var m = rows[r].querySelector('.cd__model');
        if (!m) continue;
        var idx = parseInt(rows[r].getAttribute('data-i'), 10);
        devs.push({ i: isNaN(idx) ? devs.length : idx, brand: brand, model: m.textContent, tok: tokens(brand + ' ' + m.textContent), el: rows[r] });
      }
      var more = cards[c].querySelector('.cd__more');
      if (more) more.setAttribute('data-all', more.textContent);
    }
    if (!devs.length) return false;
    devs.sort(function (a, b) { return a.i - b.i; });

    /* ---- Ab hier gilt die eingeklappte Ansicht (Klasse steht meist schon durch das Inline-Skript) ---- */
    root.classList.add('cd--js');
    var btns = root.querySelectorAll('.cd__rowbtn');
    for (var k = 0; k < btns.length; k++) {
      btns[k].setAttribute('aria-expanded', btns[k].parentNode.classList.contains('is-open') ? 'true' : 'false');
    }

    /* ---- Auf- und Zuklappen: ein Listener fuer alle Zeilen, Suchtreffer und Marken ---- */
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var btn = t.closest('.cd__rowbtn');
      if (btn && root.contains(btn)) {
        var li = btn.parentNode;
        var auf = !li.classList.contains('is-open');
        li.classList.toggle('is-open', auf);
        btn.setAttribute('aria-expanded', auf ? 'true' : 'false');
        return;
      }
      var mehr = t.closest('.cd__more');
      if (mehr && root.contains(mehr)) {
        var card = mehr.closest('.cd__card');
        if (!card) return;
        var offen = !card.classList.contains('is-open');
        var alle = mehr.getAttribute('data-all') || mehr.textContent;
        card.classList.toggle('is-open', offen);
        mehr.setAttribute('aria-expanded', offen ? 'true' : 'false');
        mehr.textContent = offen ? (T.showFewer || alle) : alle;
        if (!offen) card.scrollIntoView({ block: 'start' });
      }
    });

    /* ---- Suche ---- */
    var input = document.getElementById('cdSearch');
    var clear = document.getElementById('cdClear');
    var wrap = document.getElementById('cdResults');
    var card = document.getElementById('cdResultCard');
    var timer = null;

    function search(q) {
      var qt = tokens(q);
      if (!qt.length) return [];
      var hits = [];
      devs.forEach(function (d) {
        var ok = true;
        for (var i = 0; i < qt.length && ok; i++) {
          var t = qt[i], found = false;
          for (var j = 0; j < d.tok.length; j++) {
            var dt = d.tok[j];
            if (dt === t || (!/^\d+$/.test(t) && t.length >= 2 && dt.indexOf(t) === 0)) { found = true; break; }
          }
          if (!found) ok = false;
        }
        if (ok) hits.push(d);
      });
      var nq = norm(q);
      hits.sort(function (a, b) {
        var ea = norm(a.model) === nq || norm(a.brand + ' ' + a.model) === nq ? 0 : 1;
        var eb = norm(b.model) === nq || norm(b.brand + ' ' + b.model) === nq ? 0 : 1;
        if (ea !== eb) return ea - eb;
        if (a.tok.length !== b.tok.length) return a.tok.length - b.tok.length;
        return a.i - b.i;
      });
      return hits.slice(0, 8);
    }
    /* Treffer = Kopie der vorhandenen Zeile, aufgeklappt und mit Markenname */
    function treffer(d) {
      var li = d.el.cloneNode(true);
      li.removeAttribute('data-i');
      li.classList.remove('cd__row--more');
      li.classList.remove('cd__row--cut');
      li.classList.add('is-open');
      var m = li.querySelector('.cd__model');
      if (m && m.parentNode) m.parentNode.insertBefore(el('span', 'cd__brandtag', d.brand), m.nextSibling);
      var b = li.querySelector('.cd__rowbtn');
      if (b) b.setAttribute('aria-expanded', 'true');
      return li;
    }
    /* Alles, was dieses Skript nachtraeglich einfuegt, traegt selbst die Klasse notranslate. Die Uebersetzungs-Engine
       liest jeden neu eingefuegten Knoten einzeln und prueft nur ihn, nicht seine Vorfahren. Die Klasse an #cdRoot
       schuetzt deshalb nur, was schon im HTML steht. */
    function notListed() {
      var c = el('div', 'cd__nl notranslate');
      c.appendChild(el('div', 'cd__nltitle', T.notListedTitle));
      c.appendChild(el('p', 'cd__nltext', T.notListedText));
      var a = el('a', 'cd__btn cd__btn--sm', T.notListedCta + (root && root.getAttribute('dir') === 'rtl' ? ' ←' : ' →'));
      a.href = T.checkUrl || (T._root || '/');
      c.appendChild(a);
      try {
        var n = parseInt(sessionStorage.getItem('cd_nl') || '0', 10) + 1;
        sessionStorage.setItem('cd_nl', String(n));           /* nur lokal, wird nie gesendet */
      } catch (e) {}
      return c;
    }
    function render() {
      var q = input.value.trim();
      if (q.length < 2) { wrap.classList.remove('visible'); clear.classList.remove('visible'); return; }
      clear.classList.add('visible');
      card.textContent = '';
      var hits = search(q);
      if (!hits.length) { card.appendChild(notListed()); }
      else {
        var ul = el('ul', 'cd__list cd__list--results notranslate');
        hits.forEach(function (d) { ul.appendChild(treffer(d)); });
        card.appendChild(ul);
        if (hits.length === 8) {
          var hint = el('p', 'cd__hint notranslate', T.notListedText);
          card.appendChild(hint);
        }
      }
      wrap.classList.add('visible');
    }
    if (input && clear && wrap && card) {
      input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(render, 90); });
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { input.value = ''; render(); } });
      clear.addEventListener('click', function () { input.value = ''; render(); input.focus(); });
      if (input.value) render();
    }
    return true;
  }

  function aufbauen() {
    var root = document.getElementById('cdRoot');
    if (!root || root.dataset.asBereit === '1') return;
    var grid = document.getElementById('cdBrands');
    var tEl = document.getElementById('cd-t');
    /* Steht die Liste nicht im HTML (Abschnitt noch im alten Stand), bleibt alles unberuehrt. */
    if (!grid || !tEl || !grid.querySelector('.cd__row')) return;
    root.dataset.asBereit = '1';
    var ok = false;
    try { ok = starten(root, grid, tEl); } catch (e) { ok = false; }
    /* Geht etwas schief, bleibt die ganze Liste offen sichtbar statt eingeklappt und stumm. */
    if (!ok) root.classList.remove('cd--js');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', aufbauen); else aufbauen();
  document.addEventListener('shopify:section:load', aufbauen);
  window.addEventListener('pageshow', aufbauen);
})();
